import axios from "./axiosConfig";

const qualityService = {
  getByPeriod(year, month) {
    return axios.get("/quality", {
      params: { year, month },
    });
  },

  upsert(data) {
    return axios.post("/quality", data);
  },
};

export default qualityService;
